import React, { useEffect, useRef, useState, useCallback } from "react";
import {
  Box,
  Typography,
  Slider,
  Checkbox,
  Button,
  Divider,
  Grid,
  Link,
  IconButton,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
} from "@mui/material";
import CreditCardIcon from "@mui/icons-material/CreditCard";
// import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { renderPaymentIcon } from '../../../utils/utils';
import Axios from "../../../config/axios";
import { UrlConstant } from "../../../commom/UrlConstant";
import PaymentMethodIcon from "../SvgIcons/PaymentMethodIcon";
import { usePriceFormatter } from "../../../hooks";
interface LoanDetailsProps {
  tickerData: any;
  setOtpModalOpen: any;
  setloaninfo: () => void;
  setpayment: () => void;
  loanAmountData: any;
  loanElogibilityData: any;
  setOnBoosterLoan: any;
  setRecalculate: any;
  setLoanAmount: any;
  setLoanEligibilityData: any;
  onRecalculate: any;
  stockQty: any;
  estimatedAmount: any;
  boosterLoading: any;
  recalculate: any;
  onBuyNow: any;
  acceptCondition: boolean;
  setacceptCondition: any;
  selectedPaymentMethod: any;
  isGlobalLoading?: boolean;
  stockDetail: any;
  decimals: number;
}

const LoanDetails: React.FC<LoanDetailsProps> = ({
  tickerData,
  stockDetail,
  setOtpModalOpen,
  loanAmountData,
  loanElogibilityData,
  boosterLoading,
  isGlobalLoading,
  setLoanEligibilityData,
  onRecalculate,
  setOnBoosterLoan,
  setRecalculate,
  stockQty,
  estimatedAmount,
  setLoanAmount,
  setloaninfo,
  recalculate,
  setpayment,
  onBuyNow,
  acceptCondition,
  setacceptCondition,
  selectedPaymentMethod,
  decimals
}) => {

  // const [loanAmount, setLoanAmount] = React.useState<number>();
  // const [recalculate, setRecalculate] = React.useState<boolean>(false);
  const icon = renderPaymentIcon(selectedPaymentMethod, 16);
  const totalEstimatedAmount = Number(estimatedAmount) + Number(loanAmountData?.offer?.offerPrice)
  const currentPrice = tickerData?.lastPrice ?? 0;
  const usrQty = currentPrice > 0 ? Number(estimatedAmount) / currentPrice : 0;
  const loanQty = currentPrice > 0 ? Number(loanAmountData?.offer?.offerPrice) / currentPrice : 0;
  const totalQty = usrQty + loanQty;
  const formatter = usePriceFormatter();

  const [sliderValue, setSliderValue] = useState<number>(loanElogibilityData?.offer?.offerPrice || loanElogibilityData?.offer?.minimumAmount || 0);

  const [termsOpen, setTermsOpen] = useState(false);
  const [termsHtml, setTermsHtml] = useState<string>("");
  const [termsLoading, setTermsLoading] = useState<boolean>(false);

  const handleOpenTerms = useCallback(async (e?: React.MouseEvent) => {
    e && e.preventDefault();
    setTermsOpen(true);
    setTermsLoading(true);
    try {
      const symbol = (stockDetail?.symbol || stockDetail?.ticker || stockDetail?.stockInfo?.symbol || "").toString();
      const resp = await Axios.post(UrlConstant.BoosterLoan.ConfirmationHtml, { symbol });
      const htmlContent = resp?.data?.data ?? resp?.data ?? "";
      setTermsHtml(typeof htmlContent === 'string' ? htmlContent : "");
    } catch (_err) {
      setTermsHtml("<div style=\"color:#fff\">Failed to load Terms & Conditions. Please try again later.</div>");
    } finally {
      setTermsLoading(false);
    }
  }, []);

  const handleCloseTerms = useCallback(() => {
    setTermsOpen(false);
  }, []);

  useEffect(() => {
    setSliderValue(
      loanElogibilityData?.offer?.offerPrice || loanElogibilityData?.offer?.minimumAmount || 0
    );
  }, [loanElogibilityData]);

  const handleSliderChange = useCallback((_: Event, newValue: number | number[]) => {
    setSliderValue(newValue as number);
  }, [setSliderValue]);

  const handleSliderChangeCommitted = useCallback((_: React.SyntheticEvent | Event, newValue: number | number[]) => {
    setRecalculate(true);
    setLoanAmount(newValue as number);
  }, [setRecalculate, setLoanAmount]);


  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    let timerInterval;

    const updateCountdown = () => {
      const currentTime = Date.now();
      const timeDifference = loanAmountData?.offer?.offerExpiryDate - currentTime;

      if (timeDifference > 0) {
        const minutes = Math.floor(timeDifference / (1000 * 60));
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

        // Format time as MM:SS
        const formattedTime = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
        setTimeLeft(formattedTime);
      } else {
        setTimeLeft("00:00"); // Timer has expired
        setOnBoosterLoan(false)
        setOtpModalOpen(false)
        setLoanEligibilityData()
        clearInterval(timerInterval); // Clear interval safely
      }
    };


    if (!boosterLoading) {
      updateCountdown();
    }

    // Update the timer every second
    timerInterval = setInterval(updateCountdown, 1000);

    return () => clearInterval(timerInterval);
  }, [loanAmountData?.offer?.offerExpiryDate]);

  return (
    <>
      {
        boosterLoading && !isGlobalLoading ? (
          <Box position="relative" width="100%" minHeight={200}>
            <Box
              position="absolute"
              top={0}
              left={0}
              right={0}
              bottom={0}
              display="flex"
              alignItems="center"
              justifyContent="center"
              sx={{
                background: 'transparent',
              }}
            >
              <CircularProgress sx={{ color: "#f2674a" }} />
            </Box>
          </Box>
        ) :


          !recalculate ? (
            <>
              <Typography className="text-secondary" variant="body1">
                Your Loan Amount
              </Typography>
              <Grid container alignItems="center" justifyContent="space-between">
                <Typography className="text-white" variant="h5">{formatter.amount(sliderValue).display ?? formatter.amount(loanAmountData?.offer?.offerPrice).display}</Typography>
                <Box>
                  <Typography sx={{ color: "#f2674a" }} variant="h5">
                    {timeLeft}
                  </Typography>
                  <Typography className="text-secondary" variant="body2">
                    Remaining
                  </Typography>
                </Box>
              </Grid>

              <Slider
                value={sliderValue ?? loanAmountData?.offer?.offerPrice}
                onChange={handleSliderChange}
                onChangeCommitted={handleSliderChangeCommitted}
                min={loanElogibilityData?.offer?.minimumAmount}
                max={loanElogibilityData?.offer?.offerPrice}
                marks={loanElogibilityData?.sliderValues?.map((step) => ({ value: step }))}
                disabled={loanElogibilityData?.sliderValues?.length === 0}
                step={null}
                sx={{
                  mt: 2,
                  height: 8,
                  color: '#f2674a',
                  borderRadius: 999,
                  '& .MuiSlider-track': {
                    border: 'none',
                    backgroundColor: '#f2674a',
                  },
                  '& .MuiSlider-rail': {
                    opacity: 1,
                    background: 'linear-gradient(90deg, rgba(255,255,255,0.45) 0%, rgba(255,255,255,0.28) 60%, rgba(255,255,255,0.2) 100%)',
                  },
                  '& .MuiSlider-thumb': {
                    height: 18,
                    width: 18,
                    backgroundColor: '#FFFFFF',
                    border: '3px solid #f2674a',
                    boxShadow: '0 0 0 2px rgba(255,255,255,0.6)',
                    '&:focus, &:hover, &.Mui-active': {
                      boxShadow: '0 0 0 3px rgba(242,103,74,0.25)',
                    },
                  },
                  '& .MuiSlider-mark': {
                    display: 'none',
                  },
                }}
              />
              <Grid container justifyContent="space-between" mb={4}>
                <Typography className="text-white" variant="body2">{formatter.amount(loanAmountData?.offer?.minimumAmount).display}</Typography>
                <Typography className="text-white" variant="body2">{formatter.amount(loanElogibilityData?.offer?.offerPrice).display}</Typography>
              </Grid>
              <Box
                mt={1}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography className="text-secondary" variant="body1" color="gray">
                  Qty.
                </Typography>
                <Typography className="text-white" variant="body1">{formatter.quantity(loanQty).display}</Typography>
              </Box>
              {(() => {
                const percentage = loanAmountData?.offer?.originationFeePercentageAmount;
                const dollar = loanAmountData?.offer?.originationFeeDollar;

                const fee = Number(percentage) > 0 ? percentage : dollar;

                return Number(fee) > 0 ? (
                  <Box mt={1} display="flex" justifyContent="space-between" alignItems="center">
                    <Typography className="text-secondary" variant="body1">
                      Origination Fee
                    </Typography>
                    <Typography className="text-white" variant="body1">
                      {formatter.amount(Number(fee)).display}
                    </Typography>
                  </Box>
                ) : null;
              })()}

              {loanAmountData?.offer?.serviceCharge === 'apr_percentage' &&
                <Box
                  mt={1}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography className="text-secondary" variant="body1" color="gray">
                    Interest(APR)
                  </Typography>
                  <Typography className="text-white" variant="body1">{loanAmountData?.offer?.serviceInterest || 0}%</Typography>
                </Box>
              }
              {loanAmountData?.offer?.serviceCharge === 'apr_percentage' ?
                <Box
                  mt={1}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography className="text-secondary" variant="body1" color="gray">
                    Interest Amount
                  </Typography>
                  <Typography className="text-white" variant="body1">
                    {formatter.amount(loanAmountData?.offer?.serviceInterestAmount).display}
                  </Typography>
                </Box> :
                <Box
                  mt={1}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography className="text-secondary" variant="body1" color="gray">
                    Service Fees Amount
                  </Typography>
                  <Typography className="text-white" variant="body1">
                    {formatter.amount(loanAmountData?.offer?.serviceFee).display}
                  </Typography>
                </Box>
              }
              <Box
                mt={1}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography className="text-secondary" variant="body1" color="gray">
                  Total Loan Amount
                </Typography>
                <Typography className="text-white" variant="body1">
                  {formatter.amount(loanAmountData?.offer?.totalAmount).display}
                </Typography>
              </Box>

              <IconButton onClick={setpayment} sx={{ width: "100%", padding: 0 }}>
                <Box
                  width="100%"
                  display="flex"
                  mt={2}
                  alignItems="center"
                  p={1}
                  sx={{ background: "linear-gradient(45deg, #4b2c20, #5e4028)" }}
                >
                  <PaymentMethodIcon />
                  <Typography variant="body2" className="text-white" sx={{ ml: 1 }}>
                    Re-Payment Method
                  </Typography>
                  <Box flexGrow={1} />
                  {icon}
                  <Typography variant="body2" sx={{ ml: 1 }} className="text-white">
                    {selectedPaymentMethod.type === 'shareSellDown'
                      ? selectedPaymentMethod.displayName
                      : `${selectedPaymentMethod.displayName} ${selectedPaymentMethod.displayNumber}`
                    }
                  </Typography>
                </Box>
              </IconButton>

              {/* Everything below is OUTSIDE the gradient background */}
              <Box mt={2}>
                <Checkbox
                  checked={!!acceptCondition}
                  onChange={(e) => { setacceptCondition(e.target.checked) }}
                  sx={{ color: "white", borderRadius: "50%", p: 0, mr: 1 }}
                />
                <Typography className="text-white" variant="body2" component="span">
                  I accept booster loan{" "}
                  <Link href="#" underline="hover" color="primary" onClick={handleOpenTerms}>
                    T&C
                  </Link>
                </Typography>
              </Box>
              {/* Footer moved to BuySell */}
            </>
          ) : (
            <Box
              padding={10}
              width="100%"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                flexDirection="column"
                gap="20px"
              >
                <svg
                  width="64"
                  height="64"
                  viewBox="0 0 64 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_768_3851)">
                    <circle
                      cx="32"
                      cy="32"
                      r="32"
                      fill="url(#paint0_linear_768_3851)"
                    />
                    <path
                      d="M20 52.4443L28.8219 40.1179H21.3293L29.6677 28.5169H20.4835L32.9304 12.4443H43.4592L34.5016 22.4745L43.1333 22.2329L32.4115 35.2843H40.9064L20 52.4443Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <linearGradient
                      id="paint0_linear_768_3851"
                      x1="32"
                      y1="0"
                      x2="20.3902"
                      y2="67.5067"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#EEA415" />
                      <stop offset="1" stopColor="#FFD25E" />
                    </linearGradient>
                    <clipPath id="clip0_768_3851">
                      <rect width="64" height="64" fill="white" />
                    </clipPath>
                  </defs>
                </svg>

                <Typography variant="h6" className="text-white text-center">
                  Looks like you have changed your Order. Re-Calculate to get a new
                  Offer.
                </Typography>
                <Button
                  variant="contained"
                  onClick={onRecalculate}
                  className="text-white fw-700 fs-18 btn mb-10"
                  sx={{
                    // width: "70%",
                    bgcolor: "#f2674a !important",
                    padding: "10px !important",
                  }}
                >
                  Re-calculate
                </Button>
              </Box>
            </Box>
          )}

      <Dialog open={termsOpen} onClose={handleCloseTerms} fullScreen>

        <DialogTitle color="white">
          Terms & Conditions
          <IconButton onClick={handleCloseTerms} sx={{ position: 'absolute', right: 8, top: 8 }} aria-label="close">
            <span style={{ fontSize: 18, color: 'white' }}>×</span>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {termsLoading ? (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
              <CircularProgress />
            </Box>
          ) : (
            <Box
              sx={{
                color: 'white',
                '& body': {
                  color: '#FFFFFF !important',
                  lineHeight: 1.6,
                  maxWidth: 'none !important',
                  margin: '0 !important',
                  padding: '20px !important',
                  background: '#141414 !important',
                  overflowX: 'auto',
                },

                '& *': {
                  maxWidth: 'none !important',
                },
                '& th': {
                  backgroundColor: '#1b1b1b',
                  color: '#ffffff',
                },
                '& td': {
                  color: '#ffffff',
                },
                '& table': {
                  borderColor: '#333',
                }
              }}
              dangerouslySetInnerHTML={{ __html: termsHtml }}
            />
          )}
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: 'space-between',
            px: 2,
            py: 1,
            borderTop: '1px solid #333',
            bgcolor: '#141414',
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={!!acceptCondition}
                onChange={(e) => setacceptCondition(e.target.checked)}
                sx={{ color: 'white' }}
              />
            }
            label={
              <Typography className="text-white" variant="body2">
                I accept Terms & Conditions
              </Typography>
            }
          />
          <Button
            variant="contained"
            className="btn-success"
            sx={{ color: 'black', borderRadius: '20px' }}
            onClick={handleCloseTerms}
          >
            Done
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default LoanDetails;
